import { documentTitleFromUploadFileName, excelMimeTypeForUpload } from './upload_policy'
import { extractExcelText } from './extract_excel_text'
import { arrayBufferToBase64 } from './bytes_base64'

export type ExcelUploadPayload = {
  originalName: string
  title: string
  content: string
  mimeType: string
  /** Base64 of the original workbook bytes; rendered to a spreadsheet on-the-fly at view time. */
  blob?: string
}

export type ExcelUploadFailure = { originalName: string; error: string }

export async function processExcelUploadFile(
  file: File,
  originalName: string,
): Promise<ExcelUploadPayload | ExcelUploadFailure> {
  let data: ArrayBuffer
  try {
    data = await file.arrayBuffer()
  } catch {
    return { originalName, error: 'read_failed' }
  }
  const extracted = await extractExcelText(data)
  if (!extracted.ok) {
    return { originalName, error: extracted.error }
  }
  const title = documentTitleFromUploadFileName(originalName)
  const content = extracted.text.length === 0 ? ' ' : extracted.text
  let blob: string | undefined
  try {
    blob = arrayBufferToBase64(data)
  } catch {
    blob = undefined
  }
  return {
    originalName,
    title,
    content,
    mimeType: excelMimeTypeForUpload(originalName),
    ...(blob ? { blob } : {}),
  }
}
